// ── Apogee pack detail routing helpers ──────────────────────────────────────
// Under CurseForge-primary identity, `mpi_id` is nullable. Prefer the MPI route
// when a pack is matched to Modpack Index; otherwise fall back to the stable
// internal `apogee_id` route so CF-primary packs remain openable.

export interface PackRouteRef {
  mpi_id?: number | null;
  apogee_id: number;
}

/** Route path to a pack detail page (MPI route when matched, else apogee_id route). */
export function packDetailPath(pack: PackRouteRef): string {
  return pack.mpi_id != null
    ? `/modpacks/${pack.mpi_id}`
    : `/modpacks/id/${pack.apogee_id}`;
}
